<template>
  <div v-if="$store.state.menu.Outlets">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card color="green" title="Торговые точки дилеров" text="Список">
            <v-btn class="mr-2" color="success" @click="openItem(null)" text>Добавить</v-btn>
            <v-btn color="primary" @click="getOutlets(false)" text>Обновить</v-btn>
            <v-data-table :headers="headers" :items="moderatorList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }" v-if="item.id!==9">
                <td class="text-xs-left">{{ item.title }}</td>
                <td class="text-xs-right min-width100">
                  <template>
                    <v-icon class="mr-3" @click="openItem(item.id)">mdi-pencil</v-icon>
                    <v-icon  v-if="$store.state.role[10]"  class="mr-2 text-danger" @click="removeItem(item.id)">mdi-close</v-icon>
                  </template>
                </td>
              </template>
            </v-data-table>
            <v-pagination v-if="last_page>1" v-model="page" class="my-4" :length="last_page"></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog width="800" v-if="currentoutletInfo" v-model="currentoutletInfo">
      <v-card class="pl-5 pr-5 pt-5 pb-4">
        <v-layout wrap>
          <v-flex sm12 xs12>
            <Loader :loading="loadingUpdate" :absolute="true" />

            <div class="body-2">Название</div>
            <v-text-field v-model="outletInfo.title"></v-text-field>
            <br />
            <div class="text-xs-center">
              <v-btn
                color="success"
                right
                @click="updateItem"
                v-bind:disabled="loading"
                text
              >Сохранить</v-btn>
              <v-btn @click="currentoutletInfo=null" color="warning" text>Закрыть</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <Dealer />
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";
import Dealer from "../components/core/Dealer";
import Purchases from "../components/core/Orders/Purchases";
import { mapMutations } from "vuex";

export default {
  data: () => ({
    password: null,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    loadingUpdate: false,
    last_page: 0,

    moderatorList: [],
    outletInfoID: null,
    currentoutletInfo: null,
    outletInfo: null,

    headers: [
      {
        sortable: false,
        text: "Название",
        value: "dealer.title"
      },
      {
        sortable: false,
        text: "",
        value: "",
        align: "right"
      }
    ]
  }),
  components: { Purchases, Loader, Dealer },
  methods: {
    getOutlets(noLoading) {
      if (!noLoading) this.loading = true;
      axios
        .get("admin/outlets/list", {
          params: {
            page: this.page
          }
        })
        .then(response => {
          this.moderatorList = response.data.data;
          this.last_page = response.data.last_page;
          this.currentoutletInfo = null;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
          this.loadingSearch = false;
        });
    },
    openItem(outletInfoID) {
      if (!outletInfoID) {
        this.outletInfoID = null;
        this.currentoutletInfo = this.outletInfo = {
          id: this.outletInfoID,
          title: ""
        };
      } else {
        this.outletInfoID = outletInfoID;
        this.currentoutletInfo = this.moderatorList.filter(
          x => x.id == this.outletInfoID
        )[0];
        this.outletInfo = this.currentoutletInfo;
      }
    },
    removeItem(itemID) {
      if (itemID) {
        this.$dialog
          .confirm("Вы точно хотите удалить?", {
            okText: "Удалить",
            cancelText: "Отмена"
          })
          .then(() => {
            this.loading = true;
            axios
              .delete("admin/outlets/delete", {
                data: {
                  id: itemID
                }
              })
              .then(response => {
                this.getOutlets();

                this.$toast.success({
                  title: "Удаление",
                  message: "Модератор удален с сервера"
                });
              })
              .catch(error => {
                this.$toast.error({
                  title: "Удаление",
                  message: "Ошибка удаления"
                });
              })
              .finally(() => {
                this.loading = false;
                this.getItems();
              });
          })
          .catch(() => {});
      }
    },
    updateItem() {
      this.loadingUpdate = true;

      axios
        .post("admin/outlets/set", this.outletInfo)
        .then(response => {
          this.$toast.success({
            title: "Пользователь",
            message: "Успешно обновили пользователя"
          });

          this.getOutlets();
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.password = null;
          this.loadingUpdate = false;
        });
    }
  },

  watch: {
    page() {
      setTimeout(() => {
        this.getOutlets();
      }, 300);
    }
  },
  mounted() {
    this.getOutlets(false);
  }
};
</script>
